import {
  CustomButton,
  CustomCollapseCard,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  CustomSelect,
  Text,
  Option,
  useText,
} from '@src/components';
import '@src/styles/managementUser/userFilter.scss';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userByFilterList, setFilterObject, clearTable } from '@src/store/slice/custUsersSlice';
import { getActiveProducts } from '@src/store/slice/customerVouGroupsSlice';
import { useHistory } from 'react-router-dom';

const UserFilter = ({ form }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { activeProductList } = useSelector((state) => state?.customerVouGroups);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const {
    filterObject,
    table: { tableProperty },
  } = useSelector((state) => state?.custUsers);

  const [productList, setProductList] = useState([]);

  useEffect(() => {
    dispatch(getActiveProducts());
  }, []);

  useEffect(() => {
    if (filterObject?.customerId && history?.location?.state === 'edit') {
      dispatch(clearTable());
      dispatch(
        userByFilterList({
          body: filterObject,
          pageNumber: tableProperty?.currentPage,
          pageSize: tableProperty?.pageSize,
        }),
      );
      form.setFieldsValue(filterObject);
    } else {
      dispatch(clearTable());
    }
  }, [history]);

  useEffect(() => {
    if (activeProductList?.length) {
      const vous = activeProductList.filter((item) => item?.vous && item?.vous?.length > 0);
      if (vous.length > 0) {
        const vousList = vous.map((item) => item?.vous).flat();
        setProductList(vousList);
      }
    }
  }, [activeProductList]);

  const handleClear = useCallback(async () => {
    form?.resetFields();
    dispatch(clearTable());
    dispatch(setFilterObject({}));
    handleSearch();
  }, [form]);

  useEffect(async () => {
    await handleClear();
  }, []);

  const handleSearch = useCallback(async () => {
    const values = await form?.validateFields();
    const body = {
      ...values,
      customerId: selectedCustomer?.customerId,
    };
    dispatch(clearTable());
    dispatch(
      userByFilterList({
        body,
        pageNumber: 1,
        pageSize: 10,
      }),
    );
    dispatch(setFilterObject({ ...body }));
  }, [dispatch, form, selectedCustomer]);

  return (
    <CustomCollapseCard className="user-filter-card" cardTitle={<Text t="filters" />}>
      <CustomForm
        name="filterForm"
        className="filter-form"
        autoComplete="off"
        initialValues={{}}
        layout={'horizontal'}
        form={form}
      >
        <div className="form-item-container">
          <div className="form-item">
            <CustomFormItem
              label={
                <div>
                  <Text t="name" />
                  <span>:</span>
                </div>
              }
              name="name"
            >
              <CustomInput
                id="companyInformation-managementUser-userFilter-name-input"
                autoComplete="off"
                height={36}
                placeholder={useText('name3')}
              />
            </CustomFormItem>
            <CustomFormItem
              label={
                <div>
                  <Text t="surname" />
                  <span>:</span>
                </div>
              }
              name="surName"
            >
              <CustomInput
                id="companyInformation-managementUser-userFilter-surName-input"
                autoComplete="off"
                height={36}
                placeholder={useText('surname2')}
              />
            </CustomFormItem>

            <CustomFormItem
              label={
                <div>
                  <Text t="loginUsernameInputForgotPassword" />
                  <span>:</span>
                </div>
              }
              name="userName"
            >
              <CustomInput
                id="companyInformation-managementUser-userFilter-userName-input"
                autoComplete="off"
                height={36}
                placeholder={useText('loginUsernameInputForgotPassword')}
              />
            </CustomFormItem>
            <CustomFormItem
              label={
                <div>
                  <Text t="productType" />
                  <span>:</span>
                </div>
              }
              name="vouId"
            >
              <CustomSelect
                id="companyInformation-managementUser-userFilter-vouId-select"
                height={36}
                placeholder={useText('choose')}
              >
                {productList?.map((item) => (
                  <Option
                    id={`companyInformation-managementUser-userFilter-vouId-${item?.vouName}-option`}
                    key={item?.vouId}
                    value={item?.vouId}
                  >
                    {item?.vouName}
                  </Option>
                ))}
              </CustomSelect>
            </CustomFormItem>
            <CustomFormItem
              label={
                <div>
                  <Text t="accountStatus" />
                  <span>:</span>
                </div>
              }
              name="statu"
            >
              <CustomSelect
                id="companyInformation-managementUser-userFilter-statu-select"
                height={36}
                placeholder={useText('choose')}
              >
                <Option
                  id="companyInformation-managementUser-userFilter-statu-1"
                  key="1"
                  value={true}
                >
                  <Text t="active2" />
                </Option>
                <Option
                  id="companyInformation-managementUser-userFilter-statu-2"
                  key="2"
                  value={false}
                >
                  <Text t="passive" />
                </Option>
              </CustomSelect>
            </CustomFormItem>

            <div className="form-footer">
              <div className="action-buttons">
                <CustomButton
                  id="companyInformation-managementUser-userFilter-clear-btn"
                  className="clear-btn"
                  onClick={handleClear}
                >
                  <Text t="clean" />
                </CustomButton>
                <CustomButton
                  id="companyInformation-managementUser-userFilter-search-btn"
                  className="search-btn"
                  onClick={handleSearch}
                >
                  <CustomImage className="icon-search" src={iconSearchWhite} /> <Text t="search" />
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      </CustomForm>
    </CustomCollapseCard>
  );
};

export default UserFilter;
